import {blue600, white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const styles = {
    subheader: {
        fontSize: 24,
        fontWeight: typography.fontWeightLight,
        backgroundColor: blue600,
        color: white
    }
};

export default styles;


// WEBPACK FOOTER //
// src/components/admin/AdminList/AdminList.css.js